<template>
  <div>
    <article
      class="fixed_content nav_fixed"
      style="z-index: 200"
    >
      <NoAddressContinueComponent
        v-if="isContinue && !isDabangSession"
        :isCart="isCart"
      />
      <div :class="[isIOS ? 'ios-margin' : 'nav']">
        <a @click="fnSelect('main')">
          <img
            v-if="!_footer.isHome"
            src="@/assets/images/icon/icon_nav_home.svg"
          />
          <img
            v-else
            src="@/assets/images/icon/iconSelect_nav_home.svg"
          />
          <span :class="_footer.isHome ? 'nav_label_on' : 'nav_label_off'">홈</span>
        </a>
        <!-- NZSC-4145: 2번 탭 월세페이 → 매매보증. 목적지(랜딩·가입 내역)가 둘 다 web-core 화면이라
             Vue 셸에서는 선택 상태가 될 일이 없다(선택 아이콘은 web-core FooterNav 가 그린다). IBK(ione) 세션은 숨김 유지 -->
        <a
          v-if="_nz_source !== 'ione'"
          @click="fnSelect('firstam')"
        >
          <img src="@/assets/images/icon/icon_nav_guarantee.svg" />
          <span class="nav_label_off">매매보증</span>
        </a>
        <a @click="fnSelect('analyze')">
          <img
            v-if="!_footer.isAnalyze"
            src="@/assets/images/icon/icon_nav_analyze.svg"
          />
          <img
            v-else
            src="@/assets/images/icon/iconSelect_nav_analyze.svg"
          />
          <span :class="_footer.isAnalyze ? 'nav_label_on' : 'nav_label_off'">분석받기</span>
        </a>
        <a @click="fnSelect('subscribe')">
          <img
            v-if="!_footer.isSubscribe"
            src="@/assets/images/icon/icon_nav_subscribe.svg"
          />
          <img
            v-else
            src="@/assets/images/icon/iconSelect_nav_subscribe.svg"
          />
          <span :class="_footer.isSubscribe ? 'nav_label_on' : 'nav_label_off'">변동알리미</span>
        </a>
        <a @click="fnSelect('mypage')">
          <img
            v-if="!_footer.isMypage"
            src="@/assets/images/icon/icon_nav_mypage.svg"
          />
          <img
            v-else
            src="@/assets/images/icon/iconSelect_nav_mypage.svg"
          />
          <span :class="_footer.isMypage ? 'nav_label_on' : 'nav_label_off'">마이페이지</span>
        </a>
      </div>
      <CustomAlert
        :visible="alertItem.visible"
        :title="alertItem.title"
        :message="alertItem.content"
        :btnText="alertItem.button"
        :cancelText="alertItem.cancelText"
        @confirm="fnAlertConfirm"
        @close="fnAlertClose"
      />
    </article>
  </div>
</template>

<script>
import "@/assets/css/common.css";

import { mapActions, mapState, mapMutations } from "vuex";
import NoAddressContinueComponent from "@/components/common/NoAddressContinue.vue";
import { alertBase } from "@/mixins/alert.js";
import DeterminedConstant from "@/mixins/order/const/orderDeterminedConstant";
import Constant from "@/mixins/analyze/const/analyzeConstant.js";
import LoanGovConstant from "@/mixins/loan/const/loanGovConstant";
import { DOBY_STATUS } from "@/enum/doby";
import { getNzSource } from "@/utils/storage";
import { fnIsFirstamEnabled } from "@/components/insurance/firstamerican/firstamAccessHelpers";
import { fnGuaranteeDestination, fnGuaranteeLocation } from "@/utils/firstamGuarantee";

export default {
  name: "FooterNavigationComponent",
  components: {
    NoAddressContinueComponent,
    CustomAlert: () => import("@/components/common/CustomAlert.vue"),
  },
  data() {
    return {
      isRoute: "",
      isValue: "",
      isIOS: "",
      isContinue: true,
      isCart: false,
      isGuaranteeResolving: false,
      alertItem: {
        visible: false,
        title: "입력 정보가 초기화됩니다",
        content: "지금까지 입력한 정보가 초기화 됩니다.<br>홈으로 이동하시겠습니까?",
        button: "확인",
        cancelText: "취소",
      },
    };
  },
  created() {
    this.fnList();
    this.fnIOS();
  },
  computed: {
    ...mapState(["_items", "_modal", "_footer", "_state"]),
    ...mapState("campaignStore", ["_nz_source"]),
    // 다방 인앱 세션(NZSC-3205): 하단 '이어하기'(결제 전 퍼널 이탈 복원)는 다방 흐름과 무관 —
    // 다방 결제완료 주소미정 건은 마이페이지 카드('주소 입력하고 리포트 받기')로 이어지므로 중복·혼선.
    // 다방 세션에서만 미노출(일반 웹은 기존 노출 유지). App.vue isDabangSession 과 동일 판별.
    isDabangSession() {
      return (
        this.$route.path.startsWith("/dabang") ||
        window.sessionStorage.getItem("dabang_entered") === "1"
      );
    },
  },
  mounted() {
    // NZSC-3454: analyze 강제활성 블록 제거.
    // 조건이 `this.$route.query` 였는데 Vue Router 는 쿼리가 없어도 {} 를 주고 {} 는 truthy 라
    // 사실상 항상 참이었다. created 의 fnList() 가 경로로 올바른 탭을 이미 정하는데
    // 그 뒤 mounted 에서 분석받기를 덧칠해, 첫 로드마다 탭이 2개 활성됐다(/main 에서 홈+분석받기 실측).
    // NZSC-3153 은 /consult 만 예외로 빼 증상 하나만 가렸고 조건 자체는 그대로였다.
    // 활성 탭의 정본은 fnList() 의 경로 판정 하나다.
    this.fnContinue();
  },

  methods: {
    ...mapActions(["acCtaBtnState"]),
    ...mapActions(["acOrderReset", "acFooterState"]),
    ...mapActions("subscribeStore", ["acSubscribeReset"]),
    ...mapActions("reportStore", ["acReportReset"]),
    ...mapActions("sciStore", ["acStoreReset"]),
    ...mapActions("orderStore", ["acOrderDeterminedList"]),
    ...mapActions("firstamStore", ["acFirstamMyApplications"]),
    ...mapMutations([Constant.ADD_COMPLETE_ADDRESS_UNSET]),
    ...mapMutations("orderDeterminedStore", [DeterminedConstant.ADD_ORDER_DETERMINED_SEQ]),
    ...mapMutations("loanGovStore", [LoanGovConstant.SET_LOAN_GOV_DELETE_ITEM]),

    fnIOS() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      this.isIOS = isIOS;

      return isIOS;
    },
    fnList() {
      this.fnAlertClose();
      switch (window.location.pathname.split("/")[1]) {
        case "analyze":
          this.acFooterState("analyze");
          break;
        case "main":
          this.acFooterState("main");
          break;
        case "subscribe":
          this.acFooterState("subscribe");
          break;
        case "mypage":
          this.acFooterState("mypage");
          break;
        case "doby":
          this.acFooterState("doby");
          break;
        case "consult":
          this.acFooterState("consult");
          break;
        default:
          this.acFooterState("");
      }
    },
    fnListSelect(value) {
      switch (value) {
        case "analyze":
          this.acFooterState("analyze");
          break;
        case "home-loan":
          this.acFooterState("analyze");
          break;
        case "main":
          this.acFooterState("main");
          break;
        case "subscribe":
          this.acFooterState("subscribe");
          break;
        case "mypage":
          this.$mixpanel_track("View Mypage");
          this.acFooterState("mypage");
          break;
        case "doby":
          this.acFooterState("doby");
          break;
        case "consult":
          this.acFooterState("consult");
          break;
        default:
          break;
      }
    },
    fnSelect(value) {
      // NZSC-3080: 하단 네비게이션 탭 click_action (사기리포트 포함 모든 화면 공통)
      // 매매보증(firstam)은 목적지 판정 뒤 fnGoGuarantee 가 destination 을 실어 tab_guarantee 를 쏜다
      const tabTargetMap = {
        main: "tab_home",
        consult: "tab_consult", // NZSC-3153 AI 계약상담 탭
        analyze: "tab_analyze",
        subscribe: "tab_alimi",
        mypage: "tab_mypage",
      };
      if (tabTargetMap[value]) this.$track_click(tabTargetMap[value]);

      // IBK 임시 라우트 처리
      if (getNzSource() === "ione") {
        if (value === "main") {
          value = "ione";
          this.acFooterState("main");
        } else {
          const originalValue = value;
          value = value + "-ione";
          this.acFooterState(originalValue);
        }
      }
      if (this.$router.currentRoute.name === "mypage" && value === "analyze") {
        this.$mixpanel_track("Click Report-analyzed");
      }
      if (this.$router.currentRoute.name !== value) {
        this.acSubscribeReset();
        this.acReportReset();
        this.acStoreReset();
      }

      if (value === "analyze") {
        if (sessionStorage.getItem("home-loan")) {
          value = "home-loan";
        }
      }

      this.setLoanGovDeleteItem();
      if (this._items.order.length === 0) {
        this.fnListSelect(value);
        if (this.$router.currentRoute.name !== value) {
          if (value === "firstam") {
            this.fnGoGuarantee();
          } else {
            this.$router.push(`/${value}`);
          }
        }
      } else {
        // 리포트 입력 퍼널(거래유형~결제) 페이지에서만 초기화 팝업 노출
        const pathname = window.location.pathname;
        const funnelSegments = [
          "/analyze/type",
          "/analyze/period",
          "/analyze/period-detail",
          "/analyze/section",
          "/analyze/area",
          "/analyze/cash",
          "/analyze/firstrepay",
          "/analyze/date",
          "/analyze/loan",
          "/analyze/price",
          "/analyze/amount",
        ];
        const isInFunnel = funnelSegments.some(seg => pathname.startsWith(seg));
        if (!isInFunnel) {
          this.acOrderReset();
          this.fnListSelect(value);
          if (this.$router.currentRoute.name !== value) {
            if (value === "firstam") {
              this.fnGoGuarantee();
            } else {
              this.$router.push(`/${value}`);
            }
          }
          return false;
        }

        this.isRoute = value;
        this.alertItem.visible = true;
      }
    },
    fnPage() {
      this.acOrderReset();
      this.fnAlertClose();
      this.fnListSelect(this.isRoute);
      if (this.isRoute === "firstam") {
        this.fnGoGuarantee();
        return;
      }
      this.$router.push(`/${this.isRoute}`);
    },
    // NZSC-4145 매매보증 탭 — 이용 중 가입 건이 있으면 가입 내역, 아니면 랜딩(web-core firstamGuarantee 와 같은 기준).
    // acFirstamMyApplications 는 비로그인이면 [] 를 돌려주므로 로그인 판정은 건수에 포함된다. 조회 실패도 [] → 랜딩.
    async fnGoGuarantee() {
      if (this.isGuaranteeResolving) return;
      this.isGuaranteeResolving = true;
      try {
        let ongoing = 0;
        if (fnIsFirstamEnabled(false)) {
          const apps = await this.acFirstamMyApplications({ force: true });
          const HIDDEN = ["REJECTED", "CANCELLED", "WITHDRAWN"];
          ongoing = (apps || []).filter(a => !HIDDEN.includes(a.current_stat)).length;
        }
        const destination = fnGuaranteeDestination(ongoing > 0, ongoing);
        this.$track_click("tab_guarantee", { destination });
        this.$router.push(fnGuaranteeLocation(destination));
      } finally {
        this.isGuaranteeResolving = false;
      }
    },
    async fnContinue() {
      const array = ["/main", "/analyze", "/subscribe", "/mypage", "/mypage#noback", "/"];
      this.$router.afterEach(async (to, from) => {
        this.acCtaBtnState(false);
        const cont = array.find(e => {
          if (e === to.fullPath) return e;
        });
        if (!cont || cont === undefined) {
          this.isCart = false;
          return false;
        }
        const result = await this.acOrderDeterminedList();
        if (result) {
          if (result.id > 0) {
            this.acCtaBtnState(true);
            this.isCart = true;
          } else {
            this.isCart = false;
          }
        } else {
          this.isCart = false;
        }
      });
    },
    fnAlertConfirm() {
      this.fnAlertClose();
      this.fnPage();
    },
    fnAlertClose() {
      this.alertItem.visible = false;
    },
  },
  mixins: [alertBase],
};
</script>

<style scoped>
/* 하단 네비 safe-area 여백 버그 수정.
   common.css 의 .fixed_content { padding-bottom: env(safe-area-inset-bottom) } 가
   배경 없는 컨테이너에 걸려, 흰 배경인 자식 .nav 가 inset 만큼 위로 밀리고
   그 아래 패딩 영역은 투명 → body 흰색이 비쳐 "떠 있는 여백"으로 보임.
   (앱 WebView edge-to-edge 에서 env() 가 시스템 네비바 높이로 잡혀 여백이 커짐)
   → 컨테이너 하단 패딩은 0으로 막고, 흰 배경인 .nav/.ios-margin 이 safe-area 까지
     직접 확장하도록 패딩을 이동. 아이콘 위치는 그대로, 흰색이 바닥까지 채워져 딱 붙음. */
/* scoped 특정성(0,2,0) > 글로벌 .fixed_content(0,1,0) 라 !important 없이 덮어씀 */
.nav_fixed {
  padding-bottom: 0;
}
.nav_fixed .nav {
  padding-bottom: calc(8px + constant(safe-area-inset-bottom));
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
}
.nav_fixed .ios-margin {
  padding-bottom: calc(8px + constant(safe-area-inset-bottom));
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
}
/* NZSC-4145: 하단 네비 아이콘 24px — Figma gnb/main(7199-1102) 아이콘 칸 24 · 28px 캔버스 세트(디자이너 재전달).
   common.css 의 22px 는 전역이라 여기(scoped)서만 덮는다. web-core FooterNav 도 24px. */
.nav_fixed .nav a img,
.nav_fixed .ios-margin a img {
  width: 24px;
  height: 24px;
}
/* NZSC-4145 디자이너 요청: 네비 상단 여백 15 → 8(web-core FooterNav 동일), 선택 탭 라벨 = 아이콘과 같은 #5087ff + 한 단계 굵게,
   미선택 라벨 = Figma Grayscale/Gray #979797. common.css 전역 규칙은 그대로 두고 여기서만 덮는다. */
.nav_fixed .nav,
.nav_fixed .ios-margin {
  padding-top: 8px;
}
.nav_fixed a span.nav_label_off {
  color: #979797;
}
.nav_fixed a span.nav_label_on {
  color: #5087ff;
  font-weight: 500;
}
</style>
